import React,{ useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useBillInvoice from "./hooks/useBillInvoice";
import moment from "moment";
import Paginations from "../../Components/Pagination/pagination";
import SendIcon from "@mui/icons-material/Send";
import { Modal, Button, Spinner } from "react-bootstrap"; // *** FIX
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SmsIcon from "@mui/icons-material/Sms";
import { ToastContainer } from "react-toastify";
import NoRecord from "../../Components/noRecord";
import GetAppIcon from '@mui/icons-material/GetApp';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


const BillInvoiceList = () => {
  const navigate = useNavigate();
  const { data, method } = useBillInvoice();

  const {
    PER_PAGE,
    page,
    count,
    invoiceMod,
    selectedInvoice,
    resendLoading,
    errors,
    clientData,
    searchFilter,
    teamMember,
    branchData
  } = data;

  const {
    setPage,
    handleCloseInvoiceModal,
    handleOpenInvoiceModal,
    resendInvoiceAPI,
    setResendSendType,
    setSearchFilter, 
    handleFilterChange, 
    applySearchFilter, 
    resetSearchFilter, 
    downloadInvoiceBill,
    setSpinner
  } = method;

  const invoiceList = data?.invoiceList ?? [];

  const [resendSendType, _setResendSendType] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  // whenever modal opens with selected invoice, copy its sendType into local state
  useEffect(() => {
    if (!invoiceMod) return;

    const defaultTypes = [
      { type: "EMAIL", email: "", isSelected: false },
      { type: "WHATSAPP", email: null, isSelected: false },
      { type: "SMS", email: null, isSelected: false },
    ];

    const invTypes = selectedInvoice?.sendType || [];

    // merge invoice sendType into default (ensures EMAIL/WHATSAPP/SMS always exist)
    const merged = defaultTypes.map((d) => {
      const found = invTypes.find((x) => x.type === d.type);
      if (!found) return d;
      return {
        ...d,
        isSelected: !!found.isSelected,
        email: d.type === "EMAIL" ? found.email || "" : null,
      };
    });

    _setResendSendType(merged);

    // optional: also set in hook if you want resendInvoiceAPI to read from hook state
    if (typeof setResendSendType === "function") setResendSendType(merged);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceMod, selectedInvoice?._id]);

  // *** same helpers like InvoiceForm
  const isTypeSelected = (type) =>
    (resendSendType || []).some((x) => x.type === type && x.isSelected);

  const toggleSendType = (type) => {
    const next = (resendSendType || []).map((x) =>
      x.type === type ? { ...x, isSelected: !x.isSelected } : x
    );
    _setResendSendType(next);
    if (typeof setResendSendType === "function") setResendSendType(next);
  };

  const updateEmailInSendType = (email) => {
    const next = (resendSendType || []).map((x) =>
      x.type === "EMAIL" ? { ...x, email } : x
    );
    _setResendSendType(next);
    if (typeof setResendSendType === "function") setResendSendType(next);
  };

  const selectedEmail =
    (resendSendType || []).find((x) => x.type === "EMAIL")?.email || "";

const [openRow, setOpenRow] = useState(null);

const toggleAccordion = (id) => {
  setOpenRow(openRow === id ? null : id);
};

  const handleView = (item) => {
    setShowLoader(true);
    setSpinner(true);

    setTimeout(() => {
      navigate(`/bill/${item?.refNumber}`);
    }, 500);
  };

  return (
    <section>
      <ToastContainer />

            {showLoader && (
              <div 
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0, 0, 0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 9999
                }}
              >
                <Spinner 
                  animation="border" 
                  role="status"
                  style={{
                    width: '4rem',
                    height: '4rem',
                    color: '#ff6a00',
                    borderWidth: '4px'
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <h2 className="page-tittle">
            <i
              className="fa-solid fa-angle-left cusgap cursor"
              onClick={() => navigate(-1)}
            />
            Billing & Invoices
          </h2>
          <hr />
        </header>
        <div className="d-flex justify-content-end align-items-center gap-3">
          <div>
            <input
              type="search"
              placeholder="Search by invoice"
              className="form-control"
              name="searchText" 
              value={searchFilter?.searchText || ""} 
              onChange={handleFilterChange}
            />
          </div>

          <div style={{ width: "200px" }}>
            <select
              className="form-select"
              name="clientId"
              value={searchFilter?.clientId || ""} 
              onChange={handleFilterChange} 
            >
              <option value="">All Clients</option>
              {clientData.map((client) => (
                <option key={client._id} value={client._id}>
                  {client.name}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: "200px" }}>
              <select
                 className={`form-select form-control`}
                  onChange={handleFilterChange} 
                   value={searchFilter?.staffId || ""} 
                    name="staffId"
                 >
                 <option value="">Team member</option>
                 {teamMember.map((member) => (
                   <option key={member._id} value={member._id}>
                     {member.name}
                   </option>
                 ))}
              </select>
          </div>
          <div>
                <select
                className={`form-select form-control`}
                name="branchId"
                  onChange={handleFilterChange} 
                   value={searchFilter?.branchId || ""} 
              >
                <option value="">
                  Select branch
                </option>
                {branchData.map((branch) => (
                  <option key={branch._id} value={branch._id}>
                    {branch.name}
                  </option>
                ))}
              </select>
          </div>

          <div>
            <input
              type="date"
              className="form-control"
              name="startDate" 
              value={searchFilter?.startDate || ""} 
              onChange={handleFilterChange} 
            />
          </div>

          <div>
            <input
              type="date"
              className="form-control"
              name="endDate"
              value={searchFilter?.endDate || ""} 
              onChange={handleFilterChange} 
            />
          </div>

       
          <button
            className="btn btn_Style"
            type="button"
            onClick={applySearchFilter}
          >
            Search
          </button>

          
          <button
            className="btn btn-secondary"
            type="button"
            onClick={resetSearchFilter} 
          >
            Reset
          </button>


          <button className='btn btn_Style' type='submit'  onClick={() => navigate("/layout/bill-invoice/bill-generate")}>Bill Generate</button>

        </div>

        <div className="table-responsive mt-3">
          <table className="table cus-table">
            <thead className="text-center tableheader">
              <tr>
                <th>Invoice Number</th>
                <th>Client</th>
                <th>Visit Type</th>
                <th>Payment Mode</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Action</th>
              </tr>
            </thead>

          <tbody>
  {invoiceList.length === 0 ? (
    <tr>
      <NoRecord />
    </tr>
  ) : (
    invoiceList.map((item) => (
      <React.Fragment key={item?._id}>
        {/* MAIN ROW */}
        <tr>
          <td>{item?.refNumber ?? "-"}</td>
          <td>{item?.clientData?.name ?? "-"}</td>
          <td>{item?.visitType ?? "-"}</td>
          <td>{item?.paymentMode ?? "-"}</td>
          <td>
            {item?.startDateTime
              ? moment(item.startDateTime).format("DD-MM-YYYY")
              : "-"}
          </td>
          <td>
            {item?.endDateTime
              ? moment(item.endDateTime).format("DD-MM-YYYY")
              : "-"}
          </td>

          {/* ACTION TD WITH ACCORDION ICON */}
          <td
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
   

            <RemoveRedEyeIcon
              // onClick={() => navigate(`/bill/${item?.refNumber}`)}
               onClick={() => handleView(item)}
            />
            <SendIcon onClick={() => handleOpenInvoiceModal(item)} />
            <GetAppIcon
              onClick={() =>
                navigate(`/bill/${item?.refNumber}?download=1`)
              }
            />
                     {/* ACCORDION ICON */}
            <span onClick={() => toggleAccordion(item._id)}>
              {openRow === item._id ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </span>
          </td>
        </tr>

        {/* ACCORDION ROW */}
        {/* {openRow === item._id && (
          <tr>
            <td colSpan={7} style={{ background: "#f9f9f9" }}>
              {item?.services?.map((service)=>(
                <div>
                  <span>{service?.serviceName}</span>
                </div>
              ))}
            </td>
          </tr>
        )} */}
        {openRow === item._id && (
  <tr>
    <td colSpan={7} style={{ background: "#f9f9f9", padding:'0px' }}>
      <table className="table table-borderless mb-0">
        <thead>
          <tr style={{ background: "#fff3e8" }}>
            {/* <th>#</th> */}
            <th>Service</th>
            <th className="text-end">Base Price</th>
            <th className="text-end">GST</th>
            <th className="text-end">Total</th>
          </tr>
        </thead>

        <tbody>
          {item?.services?.map((service, index) => (
            <tr key={service._id}>
              {/* INDEX */}
              {/* <td>{index + 1}</td> */}

              {/* SERVICE DETAILS */}
              <td>
                <div>
                  {service.serviceName}
                </div>

                {/* <div style={{ color: "#ff6b00", fontSize: "12px" }}>
                  Discount ₹{service.offer?.discountValue ?? 0}.00
                </div>

                <div style={{ fontSize: "12px", color: "#666" }}>
                  Offer: {service.offer?.offerName ?? "-"}
                </div> */}
              </td>

              {/* BASE PRICE */}
              <td className="text-end">
                {/* <div
                  style={{
                    textDecoration: "line-through",
                    color: "#999",
                    fontSize: "12px",
                  }}
                >
                  ₹{service.beforeDiscountBasePrice?.toFixed(2)}
                </div> */}

                <div>
                  ₹{service.basePrice?.toFixed(2)}
                </div>
              </td>

              {/* GST */}
              <td className="text-end">
                {/* <div
                  style={{
                    textDecoration: "line-through",
                    color: "#999",
                    fontSize: "12px",
                  }}
                >
                  ₹{service.beforeDiscountGstPrice?.toFixed(2)}
                </div> */}

                <div>
                  ₹{service.gstPrice?.toFixed(2)}
                </div>
              </td>

              {/* TOTAL */}
              <td className="text-end">
                {/* <div
                  style={{
                    textDecoration: "line-through",
                    color: "#999",
                    fontSize: "12px",
                  }}
                >
                  ₹{service.beforeDiscountFinalAmount?.toFixed(2)}
                </div> */}

                <div>
                  ₹{service.finalAmount?.toFixed(2)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </td>
  </tr>
)}

      </React.Fragment>
    ))
  )}
</tbody>

          </table>

          <div className="w-100 d-flex justify-content-center">
            {count > PER_PAGE && (
              <Paginations
                setpage={setPage}
                count={Math.ceil(count / PER_PAGE)}
                page={page}
              />
            )}
          </div>
        </div>

       
        <Modal
          centered
          size="md"
          show={invoiceMod}
          onHide={handleCloseInvoiceModal}
        >
          <Modal.Header className="d-flex align-items-center">
            <Modal.Title style={{ fontSize: 16 }} className="m-0">
              Re-send Invoice
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="mb-2 text-muted" style={{ fontSize: 13 }}>
              Ref No:{" "}
              <span className="text-dark fw-semibold">
                {selectedInvoice?.refNumber || "-"}
              </span>
            </div>

            {/* *** SAME UI AS InvoiceForm */}
            <div
              style={{ background: "#fcf6f3", borderRadius: 10, padding: 14 }}
            >
              {/* EMAIL */}
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="send_email_resend"
                  checked={isTypeSelected("EMAIL")}
                  onChange={() => toggleSendType("EMAIL")}
                />
                <label className="form-check-label" htmlFor="send_email_resend">
                  <MailOutlineIcon
                    style={{ color: "#ff6a00", fontSize: "1.2rem" }}
                  />{" "}
                  Share via Email
                </label>
              </div>

              {isTypeSelected("EMAIL") && (
                <div className="ms-4 mb-2">
                  <label className="form-label mb-1">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${
                      errors?.email ? "is-invalid" : ""
                    }`}
                    value={selectedEmail}
                    onChange={(e) => updateEmailInSendType(e.target.value)}
                    placeholder="Enter email"
                  />
                  {errors?.email && (
                    <div className="invalid-feedback d-block">
                      {errors.email}
                    </div>
                  )}
                </div>
              )}

              {/* WHATSAPP */}
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="send_wa_resend"
                  checked={isTypeSelected("WHATSAPP")}
                  onChange={() => toggleSendType("WHATSAPP")}
                />
                <label className="form-check-label" htmlFor="send_wa_resend">
                  <WhatsAppIcon
                    style={{ color: "#08CB00", fontSize: "1.2rem" }}
                  />{" "}
                  Share via WhatsApp
                </label>
              </div>

              {/* SMS */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="send_sms_resend"
                  checked={isTypeSelected("SMS")}
                  onChange={() => toggleSendType("SMS")}
                />
                <label className="form-check-label" htmlFor="send_sms_resend">
                  <SmsIcon style={{ color: "#758A93", fontSize: "1.2rem" }} />{" "}
                  Share via SMS
                </label>
              </div>

              {errors?.sendType && (
                <div className="text-danger mt-2">{errors.sendType}</div>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseInvoiceModal}>
              Cancel
            </Button>

            <Button
              variant="primary"
              onClick={resendInvoiceAPI}
              disabled={resendLoading}
              style={{ background: "#ff6a00", borderColor: "#ff6a00" }}
            >
              {resendLoading ? "Sending..." : "Re-send invoice"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </section>
  );
};

export default BillInvoiceList;
